import { createBrowserRouter } from "react-router-dom";
import RootLayout from "../layout/RootLayout";
import PortfolioPage from "../pages/Portfolio";
import HomePage from "../pages/Home";
import Contact from "../pages/Contact";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        path: "/",
        element: <HomePage/>,
      },
      {
        path: "/portfolio",
        element: <PortfolioPage/>,
      },
      {
        path: "/contact",
        element: <Contact/>,
      },
    ],
  },
]);
